module.exports = __webpack_public_path__ + "assets/images/02-balloon_648fb7ee5f720fe9faddf44857bed7ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/02-balloon.png
// module id = 173
// module chunks = 0